export default {
  isActive: (state) => state.isActive,
  isActiveHorizontal: (state) => state.isActiveHorizontal,
  isActiveVertical: (state) => state.isActiveVertical,
  isActiveSecondary: (state) => state.isActiveSecondary,
};
